import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { debugLinkedInQueryKeys } from './queryKeys';

interface Variables {
  threadId: string;
  message: string;
}

export function useDebugLinkedInSendAsRecruiterMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ threadId, message }: Variables) => {
      await fetchClient.POST(
        '/debug/linkedin/threads/{threadId}/send-as-recruiter',
        { params: { path: { threadId } }, body: { message } },
      );
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: debugLinkedInQueryKeys.messages(variables.threadId),
      });
      queryClient.invalidateQueries({
        queryKey: debugLinkedInQueryKeys.all,
      });
    },
  });
}
